import { Col, PageHeader, Row } from 'antd';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import RecipeFilters from '../../parts/RecipeFilters/RecipeFilters';
import { IRecipeFilters } from '../../types';
import RecipeCard from '../../parts/RecipeCard/RecipeCard';
import { useResponsiveQuery } from 'utils/responsiveQuery/useResponsiveQuery';
import { LEFT_COL_WIDTH } from 'utils/constants';

interface IProps {}

const RecipeListPage: FC<IProps> = () => {
  const { t } = useTranslation();
  const { mobileOrTablet } = useResponsiveQuery();

  const [filters, setFilters] = useState<IRecipeFilters>({});

  const responsivePadding = mobileOrTablet ? 6 : 12;

  return (
    <>
      <PageHeader
        className="page-header"
        title={t('Recipe.Recipes', 'Recipes')}
      />
      <Row
        wrap={mobileOrTablet}
        gutter={responsivePadding}
        style={{
          paddingLeft: responsivePadding,
          paddingTop: responsivePadding,
          width: '100%',
        }}
      >
        <Col
          style={{
            paddingBottom: 6,
            width: LEFT_COL_WIDTH,
            minWidth: mobileOrTablet ? '100%' : LEFT_COL_WIDTH,
          }}
        >
          <RecipeFilters filters={filters} onFiltersChange={setFilters} />
        </Col>
        <Col flex={1}>
          <RecipeCard filters={filters} />
        </Col>
      </Row>
    </>
  );
};

export default RecipeListPage;
